export const INSIGHTS_PAGE_LIMIT = 50;

export const InsightTabs = {
  Overview: "",
  Portals: "portals",
  Assets: "assets",
  Kits: "kits",
  Users: "users",
  Storage: "storage",
  "Direct Links": "direct-links",
};
